import { ComponentType, ReactElement } from 'react';

import { protectFeature } from '~libs.shared.system';

type WithReceptionServiceGuardOptions = {
   allowReadOnly?: boolean;
};

export const withReceptionServiceGuard = <PROPS extends Record<string, unknown> & { children?: ReactElement }>(
   WrappedComponent: ComponentType<PROPS>,
   options: WithReceptionServiceGuardOptions = {}
): ((props: PROPS) => JSX.Element | ReactElement | null) => {
   const Component = (props: PROPS): JSX.Element | ReactElement | null => {
      const searchingAvailable = protectFeature('searchingPrivateMedicalServices');
      const readOnlyAvailable = protectFeature('privateMedicalServicesReadOnly');
      const visible = searchingAvailable || (Boolean(options.allowReadOnly) && readOnlyAvailable);

      return visible ? <WrappedComponent {...props} /> : props.children ?? null;
   };

   Component.displayName = 'ReceptionServiceGuard';
   return Component;
};
